import { useQuery } from "@tanstack/react-query";
import { api } from "../api/client";

/**
 * Public server settings the sign-in screens need before a user exists — chiefly
 * whether self-registration is open. Defaults to "open" while loading or on error
 * so the UI never wrongly hides registration; the backend is the real gate.
 */
export function useAuthConfig() {
  const { data } = useQuery({
    queryKey: ["auth-config"],
    queryFn: () => api.auth.config(),
    staleTime: Infinity,
    retry: false,
  });
  return { registrationOpen: (data?.registration ?? "open") === "open" };
}
